import {Directive, ElementRef, Host, HostListener, Input, OnInit, SkipSelf} from '@angular/core';
import {AbstractControl, ControlContainer} from '@angular/forms';

@Directive({
    selector: '[utilsTransformDate][formControlName]'
})
export class TransformDateDirective implements OnInit {

    private static readonly dayAndMonthDelimeter = 2;
    private static readonly yearDelimeter = 5;
    private static readonly delimeterPattern = new RegExp('(\\d{2})\\.?(\\d{2})\\.?(\\d{4})');
    @Input()
    public formControlName: string;

    private control: AbstractControl;

    constructor(@Host() @SkipSelf() private readonly controlContainer: ControlContainer,
                private readonly elementRef: ElementRef) {
    }

    private static formatValue(value: string): string {
        value = value.replace(TransformDateDirective.delimeterPattern, '$1.$2.$3');
        return value;
    }

    private static handleDragAndPaste(data: string): boolean {
        return !!data.match(TransformDateDirective.delimeterPattern);
    }

    @HostListener('blur')
    public patchValue(): void {
        if (!this.control) {
            return;
        }

        let value: string = this.elementRef.nativeElement.value;
        if (!value) {
            return;
        }

        value = TransformDateDirective.formatValue(value);
        this.control.patchValue(value);
        this.control.updateValueAndValidity();

        // formatierten Wert anzeigen
        this.elementRef.nativeElement.value = value;
    }

    @HostListener('keypress', ['$event'])
    public onKeypress(keyboardEvent: KeyboardEvent): boolean {
        const currentKey = keyboardEvent.key;

        if (currentKey !== '.') {
            return true;
        }

        const caretPosition = (keyboardEvent.target as HTMLInputElement).selectionStart;
        const value: string = this.elementRef.nativeElement.value;

        const firstIndexOfDot = value.indexOf('.');
        const lastIndexOfDot = value.lastIndexOf('.');

        // Eingabe eines Punkts nur nach jeweils zwei vorhergehenden Ziffern zulässig (Pattern: dd.MM.)
        return (
            (caretPosition === TransformDateDirective.dayAndMonthDelimeter &&
                firstIndexOfDot !== TransformDateDirective.dayAndMonthDelimeter) ||
            (caretPosition === TransformDateDirective.yearDelimeter &&
                lastIndexOfDot !== TransformDateDirective.yearDelimeter)
        );
    }

    @HostListener('paste', ['$event'])
    public onPaste(event: Event): boolean {
        const clipboardData = (event as ClipboardEvent).clipboardData;
        return TransformDateDirective.handleDragAndPaste(clipboardData.getData('Text'));
    }

    @HostListener('drop', ['$event'])
    public onDrop(dragEvent: DragEvent): boolean {
        return TransformDateDirective.handleDragAndPaste(dragEvent.dataTransfer.getData('Text'));
    }

    public ngOnInit(): void {
        if (!this.controlContainer) {
            return;
        }

        this.control = this.controlContainer.control.get(this.formControlName);
        if (!this.control) {
            return;
        }
    }

}
